// Storage.js
const storeToken = (token) => {
  try {
    window.localStorage.setItem("token", token);
  } catch (error) {
    console.log("Error getting in store token!", error);
  }
};

const getToken = () => {
  try {
    return window.localStorage.getItem("token");
  } catch (error) {
    console.log("Error getting in token", error);
  }
};

const getUserData = () => {
  try {
    return JSON.parse(window.localStorage.getItem("userData"));
  } catch (error) {
    console.log("Error getting userData", error);
    return null;
  }
};

export { storeToken, getToken, getUserData };
